import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedDate } from 'react-intl';
export const formatDate = ({ value, }) => (_jsx(FormattedDate, { value: value, month: "short", day: "2-digit", hour12: false, hour: "2-digit", minute: "2-digit" }));
